import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import CostObjectForm from "./CostObjectform";
import CostObjectEdit from "./CostObjectEdit";
import CostObjectTable from "./table";
import CostObjectFilterComponent from "./CostObjectFilterComponent";

function CostObjectPage() {
  const [dataVersion, setDataVersion] = useState(0);
  const [copiedData, setCopiedData] = useState<any>(null);
  const [isEditMode, setEditMode] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>(null);
  const [costFilters, setCostFilters] = useState<Record<string, any>>({});

  useEffect(() => {
    console.log("this the copied data ", copiedData);
  }, [copiedData]);

  useEffect(() => {
    console.log("dataVersion updated:", dataVersion);
  }, [dataVersion]);

  return (
    <>
      <div>
        <div className="page-body">
          {isEditMode ? (
            <Container fluid>
              <div className="table-ad">
                <CostObjectEdit
                  dataVersion={dataVersion}
                  setDataVersion={setDataVersion}
                  isEditMode={isEditMode}
                  editedData={editedData}
                  setEditMode={setEditMode}
                  setCopiedData={setCopiedData}
                  setEditedData={setEditedData}
                />
              </div>
            </Container>
          ) : (
            <Container fluid>
              <div className="table-ad">
                <CostObjectForm
                  dataVersion={dataVersion}
                  setDataVersion={setDataVersion}
                  copiedData={copiedData}
                />
              </div>
            </Container>
          )}

          <Container fluid>
            <CostObjectFilterComponent onApplyFilters={setCostFilters} />
          </Container>

          <CostObjectTable
            dataVersion={dataVersion}
            setDataVersion={setDataVersion}
            setCopiedData={setCopiedData}
            setEditMode={setEditMode}
            setEditedData={setEditedData}
            externalFilters={costFilters}
          />
        </div>
      </div>
    </>
  );
}

export default CostObjectPage;